import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderDetailManagementTable } from '../../OrderDetailManagementTable';
import { formatDate, formatPrice } from '@utils/format';
import { OrderBill } from '@types';

export interface BillingTableProps {
    bills: OrderBill[];
    showEditModal: (id: string) => void;
}

export const BillingTable: FC<BillingTableProps> = ({ bills, showEditModal }) => {
    const { t } = useTranslation();

    const translations = {
        number: t('billing-table-component.header.number'),
        date: t('billing-table-component.header.date'),
        file: t('billing-table-component.header.file'),
        value: t('billing-table-component.header.value'),
    };

    return (
        <OrderDetailManagementTable
            header={[
                { text: translations.number },
                { text: translations.date },
                { classes: 'text-center', hideOnMobile: true, text: translations.file },
                { classes: 'text-end', hideOnMobile: true, text: translations.value },
            ]}
            content={bills.map((bill) => {
                return {
                    cells: [
                        { content: bill.number },
                        { content: formatDate(bill.date) },
                        { classes: 'text-center', content: bill.file },
                        { classes: 'text-end', content: formatPrice(bill.value) },
                    ],
                    options: [
                        {
                            icon: 'fa-light fa-pen-to-square',
                            action: () => showEditModal(bill.id),
                        },
                        {
                            icon: 'fa-light fa-trash-can',
                            action: () => alert('#TODO: delete bill'),
                        },
                    ],
                };
            })}
        />
    );
};
